import type React from 'react';

import type { IconProps } from '../types';

export const ExclamationMarkTriangleXs: React.FC<IconProps> = ({ color = 'currentColor', ...props }) => (
  <svg fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.18883 1C8.68558 1.00014 9.10547 1.27734 9.3109 1.7002L14.8851 13.0801C15.2543 13.838 14.7314 14.7499 13.8431 14.75H2.15758C1.29963 14.7499 0.738517 13.8506 1.11558 13.0801L6.75816 1.56055C6.93359 1.21484 7.25882 1 7.6566 1H8.18883ZM2.7025 13.25H13.2982L8.03258 2.5H7.96715L2.7025 13.25ZM8.00035 10C8.41455 10 8.75035 10.3358 8.75035 10.75V11.25C8.75035 11.6642 8.41455 12 8.00035 12C7.58614 12 7.25035 11.6642 7.25035 11.25V10.75C7.25035 10.3358 7.58614 10 8.00035 10ZM8.00035 5.25C8.41455 5.25002 8.75035 5.5858 8.75035 6V8.25C8.75035 8.6642 8.41455 8.99998 8.00035 9C7.58614 9 7.25035 8.66421 7.25035 8.25V6C7.25035 5.58579 7.58614 5.25 8.00035 5.25Z"
      fill={color}
    />
  </svg>
);
